/* eslint-disable @typescript-eslint/no-shadow */
/* eslint-disable @typescript-eslint/no-unused-vars */
import React from 'react';
import usePagination from '@mui/material/usePagination/usePagination';
import styled from '@emotion/styled';
import { ReactComponent as ArrowLeftIcon } from 'common/icons/arrow-left.svg';
import { ReactComponent as ArrowRightIcon } from 'common/icons/arrow-right.svg';
import { ReactComponent as ArrowDoubleLeftIcon } from 'common/icons/arrow-double-left.svg';
import { ReactComponent as ArrowDoubleRightIcon } from 'common/icons/arrow-double-right.svg';

type PaginationProps = {
  count: number;
  page: number;
  setPage: (page: number) => void;
};

const PaginationWrapper = styled.ul`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  list-style: '';
  padding: 0;
  margin: 0;
`;

const CustomButton = styled.button`
  height: 40px;
  width: 40px;
    border-radius: 8px;
    border: 1px solid ${(props) => props.theme.colors.gray};
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 100%; /* 16px */
    letter-spacing: 1px;
    color: ${(props) => props.theme.colors.primaryTextColor};
  &:hover {
    // .1 opacity
    background-color: ${(props) => props.theme.colors.primaryColor + '1A'};
  }
  &.active {
    background-color: ${(props) => props.theme.colors.primaryColor};
    color: ${(props) => props.theme.colors.secondaryTextColor};
    border-color: ${(props) => props.theme.colors.primaryColor};
  }
  &:disabled {
    cursor: default;
    opacity: .5;
  }
`;

const CustomEllipsis = styled.div`
    display:flex;
    align-items: flex-end ;
    justify-content: center;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 100%; /* 16px */
    letter-spacing: 1px;
    width: 40px;
    height: 40px;
`;


export default function Pagination({ count, page, setPage }: PaginationProps) {
  const { items } = usePagination({
    count: count,
    page: page,
    onChange: (event, page) => setPage(page),
  });
  return (
        <PaginationWrapper>
            <CustomButton type="button" disabled={page === 1} onClick={() => setPage(1)}>
                <ArrowDoubleLeftIcon className='svg-black' />
            </CustomButton>
            {items.map(({ page, type, selected, ...item }, index) => {
              let children = <>null</>;

              if (type === 'start-ellipsis' || type === 'end-ellipsis') {
                children = <CustomEllipsis>...</CustomEllipsis>;
              } else if (type === 'page') {
                children = (
                        <CustomButton
                            type="button"
                            className={selected ? 'active' : ''}
                            {...item}
                        >
                            {page}
                        </CustomButton>
                );
              } else {
                children = (
                        <CustomButton type="button" {...item}>
                            {type === 'previous' ? <ArrowLeftIcon className='svg-black' /> : <ArrowRightIcon className='svg-black' />}
                        </CustomButton>
                );
              }
              if (children) {
                return <li key={index}>{children}</li>;
              }
              return null;
            })}
            <CustomButton
                type="button"
                disabled={page === count}
                onClick={() => setPage(count)}
            >
                <ArrowDoubleRightIcon className='svg-black' />
            </CustomButton>
        </PaginationWrapper>
  );

}